import { runClientComponent } from '../../_common/client/client-component-runner';
import { WishlistBtnComponent } from './wishlist-btn.component';

runClientComponent({ WishlistBtnComponent });
